import type { ActivityModule } from '../../core/activity';
import { runMemoryMathActivity, type MemoryMathLevelsFile } from '../../shared/memory-math-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as MemoryMathLevelsFile).levels;

export const memoryMathAdd: ActivityModule = {
  id: 'memory-math-add',
  title: 'Memória — Adição',
  description: 'Jogo da memória onde cada par é formado por uma expressão (ex: 3+4) e seu resultado (7). Treine a tabuada de soma.',
  ageMin: 7,
  ageMax: 10,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/memory-math-add/icon.svg',
  category: 'memoria',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runMemoryMathActivity(ctx, {
      activityId: 'memory-math-add',
      title: 'Memória — Adição',
      hint: 'Encontre o par: expressão ↔ resultado.',
      levels: LEVELS,
    }),
};
